import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

const UserMailIcon = createIcon({
  displayName: 'UserMailIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g xmlns="http://www.w3.org/2000/svg" fill="none">
        <path d="M24,0H0V24H24Z" fill="none" />
        <rect width="24" height="24" fill="none" />
        <path d="M0,0H24V24H0Z" fill="none" />
        <path
          d="M7,17a2.5,2.5,0,0,1,2.5-2.5H11"
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.4824"
        />
        <circle
          cx="12"
          cy="9.5"
          r="2.5"
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
        />
        <path
          d="M10,21H8a5,5,0,0,1-5-5V8A5,5,0,0,1,8,3h8a5,5,0,0,1,5,5v4"
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
        />
        <rect
          x="13"
          y="15.00001"
          width="9"
          height="7"
          rx="2"
          stroke-width="1.5"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          fill="none"
        />
        <path
          d="M15.5,17.5l1.5.866a1,1,0,0,0,1,0l1.5-.866"
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
        />
      </g>
    </>
  ),
})

const UserMail: FC<IconProps> = (props) => {
  return <CustomIcon as={UserMailIcon} {...props} />
}

export default memo(UserMail)
